import { SourceProps } from 'react-map-gl';

export default function getCountiesSource(): SourceProps {
  return {
    id: 'counties',
    type: 'vector',
    url: 'mapbox://sbcherre.census',
  };
}
